module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/play-logo-aa87c02dc079a1c57bed4114f3e4b2d4.png";